import React, { useEffect } from "react";
import MediaPlayer from "../../components/global/Multimedia/MediaPlayer";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";
import { getMultimediaFromSlug } from "../../lib/multimediaRequests";
import { getMediaURL } from "../../utils/media";

import { GetServerSideProps } from "next";
import { useToast } from "../../context/toastContext";

const Media = ({ video, errorLoading }) => {
  const toast = useToast();

  useEffect(() => {
    if (errorLoading) {
      toast("error", errorLoading);
    }
  }, [errorLoading]);

  return (
    <Layout>
      <Header />
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      {video && (
        <>
          <MediaPlayer url={getMediaURL(video)} autoplay={true} />
          <div className="p-5">
            <h3 className="text-xl">{video.title}</h3>
            <p className="font-light">{video.caption}</p>
          </div>
        </>
      )}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const cookies = req.headers.cookie;

  const { slug } = context.params;
  let video = null;
  if (slug && slug.length > 0) {
    try {
      const multimedia = await getMultimediaFromSlug(slug[0], cookies);

      video = multimedia.data;
    } catch (error) {
      if (error.data?.status === 404) {
        return {
          notFound: true,
        };
      } else {
        return {
          props: {
            errorLoading: `Failed to fetch video data ${error.data.error}`,
          },
        };
      }
    }
  }

  return {
    props: {
      video,
    },
  };
};

export default Media;
